import React, { useContext, useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { SalesforceContext, Steps, CustomerTypes } from 'src/context/salesforce-context';
import TealiumEvents from 'src/helpers/tealium-events';
import { OnboardingFormBackground } from '../../onboarding-form-background/onboarding-form-background';
import { SalesforceValidateOtpForm, ShapesDecorativeBorder } from 'src/components';
import useTechnicalErrorHandler from 'src/hooks/useTechnicalError';
import { onboardingCreateAccountRedirect } from 'src/routing/routes';
import { parseObjectToQueryParamString } from 'src/helpers/functional-helpers';
import './pos-distribution-otp.scss';

export const getQueryParams = ({ stepName, subStepName, userHasSelectedDevices = false }) => {
  let stepNameAdjusted = stepName;
  let subStepNameAdjusted = subStepName;
  let skipCurrentStep = true;

  if (stepName === Steps.LETS_GET_STARTED) {
    stepNameAdjusted = Steps.BUSINESS_TYPE;
    skipCurrentStep = false;
  } else if (stepName === Steps.BUSINESS_TYPE) {
    skipCurrentStep = false;
  } else if (stepName === Steps.MONTHLY_CARD_TURNOVER) {
    stepNameAdjusted = Steps.CHOOSE_A_SOLUTION;
    skipCurrentStep = false;
  } else if (stepName === Steps.CHOOSE_A_SOLUTION) {
    skipCurrentStep = userHasSelectedDevices;
  } else if (stepName === Steps.CONFIRM_APPLICATION) {
    subStepNameAdjusted = null;
    skipCurrentStep = false;
  }

  const queryParams = {
    step: stepNameAdjusted,
    'skip-current-step': skipCurrentStep,
  };

  if (subStepNameAdjusted) {
    queryParams['sub-step'] = subStepNameAdjusted;
  }

  return queryParams;
};

export default function PosDistributionOtp() {
  const [redirectToRoute, setRedirectToRoute] = useState('');
  const {
    resumeSessionSubmitOTP,
    otpEmailAddress,
    resumeSessionRequestOTP,
    customerType,
    setCustomerType,
    isLoadingFromSessionStorage,
  } = useContext(SalesforceContext);
  const handleTechnicalError = useTechnicalErrorHandler();

  useEffect(() => TealiumEvents.enterReferenceLoadPosDist(), []);

  useEffect(() => {
    if (!isLoadingFromSessionStorage) {
      setCustomerType(CustomerTypes.posDist);
    }
  }, [isLoadingFromSessionStorage]);

  if (!!redirectToRoute) {
    return <Redirect push to={redirectToRoute} />;
  }

  const handleCorrectOTPSuccess = (result) => {
    TealiumEvents.successfulOTPPosDist();
    const userHasSelectedDevices =
      Object.keys(result.merchant?.opportunity?.deliveries || {}).length > 0;
    const queryParams = getQueryParams({
      stepName: result.stepName,
      subStepName: result.subStepName,
      userHasSelectedDevices: userHasSelectedDevices,
    });
    const queryParamsString = parseObjectToQueryParamString(queryParams);
    setRedirectToRoute(`${onboardingCreateAccountRedirect}?${queryParamsString}`);
  };

  const form = () => (
    <section className="pos-distribution-otp">
      <SalesforceValidateOtpForm
        otpEmailAddress={otpEmailAddress}
        resendOtp={resumeSessionRequestOTP}
        submitOtp={resumeSessionSubmitOTP}
        onOtpResendButtonClick={() => {
          TealiumEvents.continueApplicationOTPClickRequestNew(customerType);
        }}
        onOtpValidateButtonClick={() => {
          TealiumEvents.clickOTPPosDist();
        }}
        onOtpIncorrect={(errorMsg) => {
          TealiumEvents.continueApplicationOTPEventError(errorMsg, customerType);
        }}
        onOtpExpired={(errorMsg) => {
          TealiumEvents.continueApplicationOTPEventError(errorMsg, customerType);
        }}
        onOtpAttemptsExceeded={(errorMsg) => {
          TealiumEvents.continueApplicationOTPEventError(errorMsg, customerType);
        }}
        onTechnicalError={handleTechnicalError}
        onOtpValidationSuccessful={handleCorrectOTPSuccess}
        automationIdPrefix="VB_Pos_Distribution_OTP"
      />
    </section>
  );

  return (
    <OnboardingFormBackground includeMiniAppBack={true}>
      <ShapesDecorativeBorder>{form()}</ShapesDecorativeBorder>
    </OnboardingFormBackground>
  );
}
